import styles from "../../styles.scss";
import { NO_VALUE } from "@/constants";
import { Button, ButtonSize, ButtonVariant } from "@/components";
import { ModalProps } from "@/pages/requests/components/users/components/types";
import { FC } from "react";

export const ModalContent: FC<ModalProps> = ({ user, onClose }) => {
  return (
    <>
      <div className={styles.modalBody}>
        <ul className={styles.modalBodyContent}>
          <li className={styles.modalRow}>
            <div>First Name (English)</div>{" "}
            <div title={user?.WorkerFirstName}>
              {user?.WorkerFirstName || NO_VALUE}
            </div>
          </li>
          <li className={styles.modalRow}>
            <div>Last Name (English)</div>{" "}
            <div title={user?.WorkerLastName}>
              {user?.WorkerLastName || NO_VALUE}
            </div>
          </li>
          <li className={styles.modalRow}>
            <div>Full Name (Arabic)</div>{" "}
            <div title={user?.WorkerFullNameArabic}>
              {user?.WorkerFullNameArabic || NO_VALUE}
            </div>
          </li>
          <li className={styles.modalRow}>
            <div>Job Title (English)</div>{" "}
            <div title={user?.WorkerJobTitle}>
              {user?.WorkerJobTitle || NO_VALUE}
            </div>
          </li>
          <li className={styles.modalRow}>
            <div>Job Title (Arabic)</div>{" "}
            <div title={user?.WorkerJobTitleArabic}>
              {user?.WorkerJobTitleArabic || NO_VALUE}
            </div>
          </li>
          <li className={styles.modalRow}>
            <div>Residency (Arabic)</div>{" "}
            <div title={`${user?.PlaceOfIssuingResidencePermitArabic}`}>
              {user?.PlaceOfIssuingResidencePermitArabic || NO_VALUE}
            </div>
          </li>

          <li className={styles.modalRow}>
            <div>Passport #</div>{" "}
            <div title={user?.WorkerPassportNumber}>
              {user?.WorkerPassportNumber || NO_VALUE}
            </div>
          </li>
          <li className={styles.modalRow}>
            <div>Nationality</div>{" "}
            <div title={user?.WorkerNationality}>
              {user?.WorkerNationality || NO_VALUE}
            </div>
          </li>
          <li className={styles.modalRow}>
            <div>Emirated ID</div>{" "}
            <div title={user?.WorkerEmiratesId}>
              {user?.WorkerEmiratesId || NO_VALUE}
            </div>
          </li>
          <li className={styles.modalRow}>
            <div>HSE</div>{" "}
            <div title={`${user?.WorkerHseStatus}`}>
              {user?.WorkerHseStatus ? "Yes" : "No"}
            </div>
          </li>
          <li className={styles.modalRow}>
            <div>Medical Fitness</div>{" "}
            <div title={`${user?.WorkerMedicalFitnessStatus}`}>
              {user?.WorkerMedicalFitnessStatus ? "Yes" : "No"}
            </div>
          </li>
          <li className={styles.modalRow}>
            <div>Toxic Gas</div>{" "}
            <div title={`${user?.WorkerToxicGasStatus}`}>
              {user?.WorkerToxicGasStatus ? "Yes" : "No"}
            </div>
          </li>
        </ul>
      </div>

      <footer>
        <Button
          variant={ButtonVariant.Secondary}
          size={ButtonSize.Small}
          onClick={onClose}
        >
          Close
        </Button>
      </footer>
    </>
  );
};
